"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconLinkedIn = void 0;

var React = __importStar(require("react"));

exports.IconLinkedIn = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return React.createElement("svg", _objectSpread(_objectSpread({
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.362 0H29.63C30.937 0 32 1.033 32 2.305V29.689C32 30.964 30.937 31.999 29.632 31.999H2.362C1.06 31.999 0 30.964 0 29.689V2.305C0 1.033 1.06 0 2.362 0ZM9.5 11.996H4.745V27.266H9.5V11.996ZM9.869 7.146C9.869 5.629 8.636 4.396 7.119 4.396C6.75761 4.3956 6.39969 4.46644 6.0657 4.60447C5.7317 4.74249 5.42819 4.94499 5.17251 5.20039C4.91683 5.45579 4.714 5.75908 4.57561 6.09293C4.43723 6.42677 4.366 6.78461 4.366 7.146C4.36785 7.87574 4.65862 8.57506 5.17473 9.09097C5.69083 9.60689 6.39025 9.89741 7.12 9.899C8.636 9.899 9.869 8.663 9.869 7.146ZM12.476 11.996H12.469L12.476 11.993V11.996ZM12.476 11.996V27.263H17.218V19.709C17.218 17.719 17.598 15.789 20.068 15.789C22.502 15.789 22.534 18.069 22.534 19.839V27.267H27.277V18.891C27.277 14.78 26.39 11.617 21.584 11.617C19.266 11.617 17.718 12.883 17.084 14.083H17.021V11.996H12.476Z",
    fill: color
  }));
});